((document) => {
  /**
   * Helper: inject schema into <head>
   */
  function injectSchema(schema) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function createBreadcrumbSchema() {
    const path = window.location.pathname;
    const home = window.location.origin;
    const pathsArray = path.split('/').filter(Boolean);
    pathsArray.unshift('Home');
    const slugs = pathsArray.slice(1);
    const urls = [`${home}/`].concat(
      slugs.map((_, i) => `${home}/${slugs.slice(0, i + 1).join('/')}`),
    );
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: urls.map((str, index) => {
        const name = pathsArray[index]
          .split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        str = index !== 0 ? `${str}/` : str;
        return {
          '@type': 'ListItem',
          item: str,
          name,
          position: index + 1,
        };
      }),
    };
    injectSchema(breadcrumbSchema);
  }

  window.vm.onload(() => {
    createBreadcrumbSchema();
  });
})(document);
